<script lang="ts" setup>
import 'leaflet/dist/leaflet.css'
import { LIcon, LMap, LMarker, LTileLayer } from '@vue-leaflet/vue-leaflet'

const props = defineProps({
  city: {
    default: '',
    type: String,
  },
  countryCode: {
    default: '',
    type: String,
  },
  latitude: {
    default: 0,
    type: Number,
  },
  longitude: {
    default: 0,
    type: Number,
  },
  state: {
    default: '',
    type: String,
  },
  type: {
    default: 'country',
    type: String,
  },
})

const { t } = useI18n()

const zoom = ref(props.type === 'city' ? 5 : 3)

function onOpenCity() {
  let query = ''

  query = props.city ? `${props.city}` : ''
  query += props.state ? ` ${props.state}` : ''

  if (props.countryCode) {
    query += ' '
    query += t(`locations.countries.${props.countryCode}`)
  }

  window.open(`https://www.google.com/search?q=${encodeURIComponent(query)}`, '_blank')
}
</script>

<template>
  <div class="map-widget relative z-0 w-full overflow-hidden rounded-lg">
    <div class="flex size-full flex-col">
      <div class="flex-1 bg-white">
        <LMap
          v-if="latitude && longitude"
          v-model:zoom="zoom"
          :center="[latitude, longitude]"
          :max-zoom="12"
          :min-zoom="1"
          :options="{
            attributionControl: false,
            dragging: true,
            zoomControl: false,
          }"
          :use-global-leaflet="false"
        >
          <LTileLayer url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png" />

          <LMarker
            :lat-lng="[latitude, longitude]"
            @click="onOpenCity"
          >
            <LIcon>
              <WidgetMapPin
                class="-translate-x-1/2 -translate-y-1/2"
                clickable
              />
            </LIcon>
          </LMarker>
        </LMap>
      </div>
    </div>
  </div>
</template>

<style>
.leaflet-div-icon {
  background: transparent !important;
  border: none !important;
}
</style>
